/* eslint-disable react/display-name */
import { forwardRef } from "react";

import { CustomizedTypography } from "./styles";

const Text = forwardRef(
  (
    {
      children,
      component,
      variant = "bodyRegular",
      underline,
      color,
      uppercase,
      ...props
    },
    ref
  ) => {
    return (
      <CustomizedTypography
        component={component || "p"}
        underline={underline}
        uppercase={uppercase}
        ref={ref}
        color={color || "inherit"}
        variant={variant}
        {...props}
      >
        {children}
      </CustomizedTypography>
    );
  }
);

export default Text;
